import React from 'react'
import "./Spinner.css"

const Spinner = () => {
  return (
    <div className='flex justify-center items-center h-[75vh]'>
        <div className='spinner'></div>
    </div>
  )
}

export default Spinner